import React from 'react';

const SVG = ({ style = {}, colors, width = '100%', viewBox = '0 0 400 400' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g transform="rotate(45 200 200)">
      <path d="M 225,5 L 170,15 235,35 Z" fill={colors.light} />
      <path d="M 225,395 L 170,385 235,365 Z" fill={colors.light} />
      <ellipse cx="175" cy="200" rx="90" ry="155" fill="none" stroke={colors.light} strokeWidth="60" />
      <ellipse cx="235" cy="200" rx="90" ry="165" fill="none" stroke={colors.dark} strokeWidth="60" />
    </g>
  </svg>
);

export default SVG;
